import React from 'react'
import { I18n } from 'shared'
import TimeAgo from 'timeago-react'
import { register } from 'timeago.js'
import de from 'timeago.js/lib/lang/de'

register('de', de)

export const LocalTimeAgo = ({ timestamp }: { timestamp: number }) => (
  <TimeAgo datetime={timestamp * 1000} locale={I18n.locale} />
)
